<template>
    <div class="row mt-5">
<div class="col" v-for="button in buttons"  v-if="button.visible">
<button class="btn btn-block btn-lg btn-outline-primary text-center p-5"  @click="fire(button.action,button.nextstep)">
    <i class="fa-2x fa fa-chevron-left" v-if="button.action=='back'"></i>
    <i class="fa-2x fa fa-times" v-if="button.action=='wrong'"></i>
    <i class="fa-2x fa fa-check" v-if="button.action=='next' || button.action=='finish'"></i>
    <br/>
    {{button.label}}
</button>

</div>
          
        </div>
</template>

<script>
import axios from "axios";
export default {
  name: "buttons",

  props: {
    buttons: {
      type: Array,
      required: true,
      default: () => [],
    },
   
  },
  data() {
    return {
      templates: [],
      wizard: {},
      usersteps: [],
    };
  },
  computed: {
   
  },
  components: {
   
  },
  mounted() {
   
  },
  methods: {
  fire:function(action,nextstep){
    this.$emit("action",action,nextstep)

  }
  },
};
</script>